import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import { connect } from "react-redux"
import { getCurrentTimeZone } from "containers/Communications/utils"
import TableComponent from "components/Table"
import viewResultsListColumns from "./viewResultsListColumns"

const ViewResultsTab = props => {
  return (
    <Card>
      <CardBody>
        <Row>
          <Col xs="auto">Timezone:</Col>
          <Col xs="auto">{getCurrentTimeZone()}</Col>
        </Row>
        <Row className="my-3">
          <Col>
            <TableComponent
              data={props.questionnaireScores?.data}
              columns={viewResultsListColumns(props.questionnaire?.questions)}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const mapStateToProps = state => ({
  questionnaireScores: state.Questionnaire.questionnaireScores,
  questionnaire: state.Questionnaire.questionnaire,
})

export default connect(mapStateToProps)(ViewResultsTab)
